module.exports = __webpack_public_path__ + "static/Dona-Medium-78cf9a12a722774a0cecda164a1292e2.woff";